// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const GET_ASSET_PACKAGES_STATS =
  "mondoo.policy.ExtendedVulnMgmt.GetAssetPackagesStats";
